@if (isIconOnly) {
<button
  mat-icon-button
  [type]="type"
  [matTooltip]="tooltip ?? ''"
  [ngClass]="buttonClasses"
  [disabled]="isDisabled"
  [attr.aria-label]="ariaLabel"
  [attr.aria-controls]="ariaControls"
  [attr.aria-hidden]="isDisabled"
  (click)="handleClick($event)"
>
  <mat-icon
    [svgIcon]="loading ? 'loading' : svgIcon!"
    aria-hidden="false"
  ></mat-icon>
</button>
} @else {
<button
  mat-flat-button
  [type]="type"
  [matTooltip]="tooltip ?? ''"
  [ngClass]="buttonClasses"
  [disabled]="isDisabled"
  [attr.ariaLabel]="ariaLabel"
  [attr.aria-controls]="ariaControls"
  (click)="handleClick($event)"
>
  @if(hasIcon || loading){
  <mat-icon
    class="ord-icon-lg"
    [svgIcon]="loading ? 'loading' : svgIcon!"
    aria-hidden="false"
  ></mat-icon>
  } @if(hasText) {
  <ng-container [ngTemplateOutlet]="text.templateRef"></ng-container>
  }
</button>
}
